import { render } from "./ItemPrestacion.vue?vue&type=template&id=37ba56c8"
import script from "./ItemPrestacion.vue?vue&type=script&lang=js"
export * from "./ItemPrestacion.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__